import Alpine from "alpinejs";
import "./../../../NodeTypes/Index.js";

if (!window.Alpine) {
    window.Alpine = Alpine;
}
Alpine.start();

if (process.env.NODE_ENV === "development") {
    console.log("JvMTECH.Life Main.js loaded");
}
